<template>
	<div class="accountSetting pl-xl-4">
        <div class="border-bottom pb-3 mb-3">
    		<h3 class="medium "> Manage Your Confirmed Devices</h3>
            <p>Your trusted devices are used in addition to your password to verifiy your identity. You must have at least one phone number that can receive SMS messages. You currently have 2 trusted devices.</p>
        </div>
       <div class="card-body d-flex align-items-center justify-content-between border-bottom pb-4 mb-4">
            <div class="d-flex align-items-start">
                <span class="iconSave"><img src="../../../../../static/website/images/iphone.png" alt="Phone" title="Phone Numbers"></span>
                <div class="flex-shrink-0 ml-3">
                    <h6 class="medium mb-0">Stephen Bradley’s - Iphone 13 Pro </h6>
                    <p class="mt-1 mb-0">Added on: 21 February 2022 12:53 (GMT)</p>
                </div>
            </div>
            <p class="mb-0 verified green d-flex align-items-center">Verified <feather size="15px" class="ml-2" type="check"></feather></p>
            <a href="javascript:void(0)" class="flex-shrink-0 small cap_btn-b red d-flex align-items-center">Remove <feather size="15px" class="ml-1" type="x"></feather></a>
        </div>
        <div class="card-body d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-start">
                <span class="iconSave"><img src="../../../../../static/website/images/safari.png" alt="Phone" title="Phone Numbers"></span>
                <div class="flex-shrink-0 ml-3">
                    <h6 class="medium mb-0">Stephen’s Safari Browser  -  iPad Pro </h6>
                    <p class="mt-1 mb-0">Added on: 21 February 2022 12:53 (GMT)</p>
                </div>
            </div>
            <p class="mb-0 verified secondary d-flex align-items-center small cap_btn-b">Verify </p>
            <!-- <a href="javascript:void(0)" class="flex-shrink-0 small cap_btn-b red d-flex align-items-center">Remove <feather size="15px" class="ml-1" type="x"></feather></a> -->
        </div>
        <div class="d-flex align-items-center justify-content-between refresh border-top pt-4 mt-4">
            <a href="javascript:void(0)" class="textcolor"> Don’t see a device?</a>
            <a href="javascript:void(0)" class="d-flex align-items-center textcolor"> <feather size="15px" class="mr-1" type="rotate-cw"></feather> Refresh Devices</a>
        </div>
        <!-- <div class="buttons d-flex align-items-center justify-content-end mt-4">
            <a href="javascript:void(0)" class="cap_btn-b mr-3 min-auto">Cancel</a>
            <a href="javascript:void(0)" class="cap_btn small">Save</a>
        </div> -->
		
    </div>
</template>

<script>
import { registerStepsMixins } from '@/plugins/registerSteps'
// import editAddress from './edit_Address'
// import editNumber from './edit_Number'
export default {
    name: 'accountprofile',
    mixins: [registerStepsMixins],
    data() {
        return {
            notification_msg:'',
            notification_type:'',
            // tab: '1',
            submitted: false,
            // editAddress: false,
            // editNumber: false,

            fname: '',
            mName: '',
            lname: '',
            dob: '',
            address: '',
            city: '',
            state: '',
            country: '',
            area_code: '',
            acc_type: '',
            OrganizationType:{
            	'0':'Company',
            	'1':'Self Managed Super Fund',
            	'2':'Discretionary/Unit Trust',
            	'3':'Others'
            }
        }
    },
    components:{
        // editAddress,
        // editNumber 
    },

    methods: {
        create_image(url,name){
            var stx = this.stxx
            var link = document.createElement('a');
            link.download = name;
            link.href = url
            link.click();
        },
        ChangeTab(val){
            this.tab = val
            // this.editAddress = false
            // this.editNumber = false
            this.pageLoader = false
        },
        Submit() {
            const _that = this
            _that.submitted = true;
            _that.$validator.validate().then(valid => {
                if (valid) {
                    let input_json = {
                        'globalParams': {
                            'f_name': _that.fname,
                            'm_name': _that.mName,
                            'l_name': _that.lname,
                            'dob': _that.dob,
                            'Address': _that.address,
                            'City': _that.city,
                            'State': _that.state,
                            'Country': _that.country,
                            'Areacode': _that.area_code,
                            'Acc_type': _that.acc_type,
                        },
                        localParams: {
                            "parameter": _that
                        }
                    }

                }
            });
        }
    },
    created() {
        this.pageName('Account Profile')
        this._runGetProfileInfo({
            globalParams: {
				
			},
            localParams: {
                "parameter": this
            }
        })
    }
}
</script>



// WEBPACK FOOTER //
// src/components/website/settings/files/confirmed-devices.vue